export const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;



// WEBPACK FOOTER //
// ./src/utils/platform.js